import WorkoutQuestionPage from './workout-question-page';

export default WorkoutQuestionPage;
